import { PanelBody, PanelRow, TabPanel, Panel, ClipboardButton } from "@wordpress/components";

import { InspectorControls } from "@wordpress/block-editor";
import { useState } from "@wordpress/element";
import { __ } from "@wordpress/i18n";

// import { produce } from "immer";

/* eslint-disable react/prop-types */

// import BRangeControl from "./../../Components/BRangeControl";

import { BUnitControl } from "./../../../..//wp-utils/v1/components";
import Items from "../components/tabs/general/Items";
import { useEffect } from "@wordpress/element";
// import { useWPAjaxMutation } from "../../../../wp-utils/v1/hooks";

const Settings = ({ setAttributes, attributes, updateVideo }) => {
  const { videos, rowGap, columnGap } = attributes;

  const [copied, setCopied] = useState(false);

  // const { saveData: deletePreset, data: presetDeleted, isLoading: isDeleting } = useWPAjaxMutation(ytpPlayer?.ajaxURL, { nonce: ytpPlayer?.nonce, method: "deletePreset", action: "ytp_ajax", model: "Presets" });

  const postId = wp.data.select("core/editor").getCurrentPostId();
  const postType = wp.data.select("core/editor").getCurrentPostType();

  useEffect(() => {
    setTimeout(() => {
      setCopied(false);
    }, 2000);
  }, [copied]);

  return (
    <>
      <InspectorControls style={{ marginBottom: "40px" }}>
        {postType === "ytplayer" && (
          <PanelBody>
            <PanelRow>
              <div className="ytp_front_shortcode">
                <ClipboardButton
                  title={copied ? __("Copied", "ytp") : ""}
                  variant="primary"
                  text={`[ytplayer id=${postId}]`}
                  onCopy={() => setCopied(true)}
                  onFinishCopy={() => setCopied(false)}
                >
                  <span className="htooltip">{copied ? __("Copied", "ytp") : __("Copy To Clipboard", "ytp")}</span>
                  {__("Copy Shortcode", "ytp")}
                </ClipboardButton>
              </div>
            </PanelRow>
          </PanelBody>
        )}

        <TabPanel
          className="bPSS"
          activeClassName="active-tab"
          tabs={[
            {
              name: "settings",
              title: "General",
              className: "general btTab",
            },
            {
              name: "style",
              title: "Style",
              className: "style btTab",
            },
          ]}
        >
          {(tab) => {
            return (
              <span>
                {tab.name == "settings" && (
                  <span>
                    <Panel>
                      <Items setAttributes={setAttributes} updateVideo={updateVideo} videos={videos} />

                      {/* <PanelBody title={__("Presets", "ytp")}>
                        <div className={`ytp-presets ${isDeleting ? "presetDeleting" : ""}`}>
                          {presets?.length &&
                            presets?.map((item) => (
                              <>
                                <div className={`ytp-preset-item`}>
                                  <div
                                    className="box"
                                    onClick={() => {
                                      console.log("item", item.id);
                                      setAttributes({ presetID: item?.id });
                                    }}
                                  >
                                    <span>{item.name?.[0]?.toUpperCase()}</span>
                                  </div>
                                  <div className="actions">
                                    <Dashicon
                                      icon="edit"
                                      title={__("Edit", "ytp")}
                                      onClick={() => {
                                        setAttributes({ editingPresetID: item.id, presetOpened: true });
                                      }}
                                    />
                                    {presets?.length > 1 && <Dashicon icon="trash" title={__("Delete", "ytp")} onClick={() => handleDeletePreset(item.id)} />}
                                  </div>
                                  <p>{item?.name || __("Unknown Name", "ytp")}</p>
                                </div>
                              </>
                            ))}
                        </div>
                        <Button onClick={() => setAttributes({ editingPresetID: null, presetOpened: true })} variant="primary">
                          {__("Create New Preset", "ytp")}
                        </Button>
                      </PanelBody> */}
                    </Panel>
                  </span>
                )}
                {/* {tab.name == "controls" && <BControls attributes={attributes} setAttributes={setAttributes} />} */}
                {tab.name == "style" && (
                  <span>
                    <Panel>
                      <PanelBody title={__("Style", "ytp")} initialOpen={true}>
                        {/* <PanelRow>
                          <label>{__("Brand Color", "ytp")}</label>
                          <BColor value={brandColor} onChange={(value) => setAttributes({ brandColor: value })} />
                        </PanelRow> */}
                        <BUnitControl value={rowGap} onChange={(rowGap) => setAttributes({ rowGap })} label={__("Row Gap", "ytp")} labelPosition="side" />
                        <BUnitControl value={columnGap} onChange={(columnGap) => setAttributes({ columnGap })} label={__("Column Gap", "ytp")} labelPosition="side" />
                      </PanelBody>
                      <PanelBody></PanelBody>
                    </Panel>
                  </span>
                )}
              </span>
            );
          }}
        </TabPanel>
      </InspectorControls>
    </>
  );
};

export default Settings;
